import { render, staticRenderFns } from "./Template6.vue?vue&type=template&id=3d2d8cfb&scoped=true"
import script from "./Template6.vue?vue&type=script&lang=js"
export * from "./Template6.vue?vue&type=script&lang=js"
import style0 from "./Template6.vue?vue&type=style&index=0&id=3d2d8cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d8cfb",
  null
  
)

export default component.exports